import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addServiceType, getServiceType, updateServiceType, deleteServiceType} from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class ServiceType extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sertype: ''
        }
        this.handleServiceTypeSubmit = this.handleServiceTypeSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (sertype) => {
        this.setState({ sertype: sertype });
        this.setState({ deleteModal: true });
    };

    handleDeleteServiceType = () => {
        const { onDeleteServiceType } = this.props;
        const { sertype } = this.state;

        if (sertype.id !== undefined) {
            onDeleteServiceType(sertype);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleServiceTypeSubmit(value) {
        this.props.addServiceType(value, this.props.history);
    }

    componentDidMount() {
        const { onGetServiceType } = this.props;
        onGetServiceType(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { sertypes } = this.props;
        if (!isEmpty(sertypes) && size(prevProps.sertypes) !== size(sertypes)) {
            this.setState({ sertypes: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ sertype: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const sertype = arg;
        this.setState({
            sertype: {
                id: sertype.id,
                serviceTypeId: sertype.serviceTypeId,
                serviceTypeTitle: sertype.serviceTypeTitle,
                agentId: sertype.agentId,
                isActive:sertype.isActive
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { sertypes, onUpdateServiceType } = this.props;
        const { isEdit, deleteModal } = this.state;
        const sertype = this.state.sertype;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteServiceType}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Service Type")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        serviceTypeTitle: (this.state && this.state.serviceTypeTitle) || "",

                                    }}
                                    validationSchema={Yup.object().shape({
                                        serviceTypeTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleServiceTypeSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Service Type</CardTitle>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="serviceTypeTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="serviceTypeTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.serviceTypeTitle && touched.serviceTypeTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="serviceTypeTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="serviceTypeTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(sertypes, (sertype, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{sertype.serviceTypeTitle}</td>
                                                                        <td>
                                                                        <ActionEdit onClick={() => this.toggleRightCanvas(sertype)} />
                                                                        <ActionDelete onClick={() => this.onClickDelete(sertype)} />
                                                                           

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: sertype.id,
                                        serviceTypeId: sertype.serviceTypeId,
                                        serviceTypeTitle: sertype.serviceTypeTitle,
                                        agentId: sertype.agentId,
                                        isActive:sertype.isActive

                                    }}
                                    validationSchema={Yup.object().shape({
                                        serviceTypeTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                serviceTypeId: values.serviceTypeId,
                                                serviceTypeTitle: values.serviceTypeTitle,
                                                agentId: values.agentId,
                                                isActive:values.isActive
                                            };
                                            onUpdateServiceType(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="serviceTypeTitle">
                                                            {this.props.t("Title *")}
                                                        </Label>
                                                        <SafeField
                                                            name="serviceTypeTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.serviceTypeTitle && touched.serviceTypeTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="serviceTypeTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="serviceTypeTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
ServiceType.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addServiceType: PropTypes.func,
    onGetServiceType: PropTypes.func,
    sertypes: PropTypes.array,
    onDeleteServiceType: PropTypes.func,
    onUpdateServiceType: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        sertypes: AppoinmentObject.sertypes,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addServiceType: (data) => dispatch(addServiceType(data)),
    onGetServiceType: (agentId) => dispatch(getServiceType(agentId)),
    onDeleteServiceType: (id) => dispatch(deleteServiceType(id)),
    onUpdateServiceType: (data) => dispatch(updateServiceType(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ServiceType))
